import NextLink from 'next/link';
import styles from './HelpArticleTile.module.scss';
import { useCalculatedArticleFields } from 'hooks/useCalculatedArticleField';

const HelpArticleTile = ({ articleCard, baseUrl }) => {
  const { getUrl } = useCalculatedArticleFields();

  const articleUrl = getUrl(articleCard.name, baseUrl);
  return (
    <NextLink href={articleUrl} prefetch={false} className={`${styles['help-article']} h-100`}>
      <div className="d-flex flex-column flex-grow-1 background-white px-2 py-3">
        <div className="d-flex flex-column h-100 flex-grow-1 align-items-start mt-2">
          <h5>{articleCard.helpTitle.value}</h5>
          <p className="body-small text-grey mt-1 mb-4 line-clamp-3">
            {articleCard.helpStrapline.value}
          </p>
        </div>
      </div>
    </NextLink>
  );
};

export default HelpArticleTile;
